import React, { Component } from 'react';

import Radiobutton from './shared/Radiobutton';
import StarIcon from './shared/StarIcon';
import styles from './../styles/grading.styl';

class OrderTabQAItemNew extends Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.renderRow = this.renderRow.bind(this);
  }

  onChange(event) {
    const { onChange } = this.props;
    const value = event.target.value;
    const name = event.target.name;

    onChange(name, value);
  }

  renderRow(tableRow) {
    const { dataRow } = this.props;
    const { id } = tableRow;
    const currentValue = dataRow && (dataRow[id] || 0);

    return (
      <tr key={id}>
        <td>
          <span dangerouslySetInnerHTML={{ __html: tableRow.name }} />
          {tableRow.tooltip &&
            <div className={styles.tooltip}>
              <a className={styles.tooltip_trigger}> </a>
              <div className={styles.tooltip_content} dangerouslySetInnerHTML={{ __html: tableRow.tooltip }} />
            </div>
          }
        </td>
        {Object.values(tableRow.grade).map((itemValue, index) =>
        (<td key={index}>
          <Radiobutton
            disabled={!this.props.isEdit}
            onChange={this.onChange}
            name={id}
            value={itemValue || 0}
            checked={currentValue === itemValue}
          />
          {/* {tableRow.grade_view[index] || '0'} */}
          {/* </Radiobutton> */}
        </td>),
        )}
      </tr>
    );
  }

  render() {
    const { dataSection } = this.props;

    return (
      <table>
        <tbody>
          <tr>
            <th width="25%">Criterion</th>
            <th width="15%">
              <div className={styles.stras_wrap}><StarIcon /><StarIcon /><StarIcon /><StarIcon /><StarIcon /></div>
              <span>Excellent</span>
            </th>
            <th width="15%">
              <div className={styles.stras_wrap}><StarIcon /><StarIcon /><StarIcon /><StarIcon /></div>
              <span>Quite Good</span>
            </th>
            <th width="15%">
              <div className={styles.stras_wrap}><StarIcon /><StarIcon /><StarIcon /></div>
              <span>Average</span>
            </th>
            <th width="15%">
              <div className={styles.stras_wrap}><StarIcon /><StarIcon /></div>
              <span>Poor</span>
            </th>
            <th width="15%">
              <div className={styles.stras_wrap}><StarIcon /></div>
              <span>Unacceptable</span>
            </th>
          </tr>
          {Object.values(dataSection.data).map(this.renderRow)}
        </tbody>
      </table>
    );
  }
}

export default OrderTabQAItemNew;



// WEBPACK FOOTER //
// ./src/components/OrderTabQAItemNew.js